module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/evt-step2-335dab82cb211a5393d49c275dfc2a59.svg";